/*=========================================================================================
  File Name: moduleReportFormConfigActions.js
  Description: Request Type Config Module Actions

==========================================================================================*/
import requestGQL from "@/http/requests/request";
import reportFormGQL from "@/http/requests/agile/form_gql.js";

export default {
	getReportForm({ commit }, {id, list_all_controls}) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.getReportForm(id,list_all_controls)
				.then(response => {
					commit("SET_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateReportForm({ commit }, payload) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.updateReportForm(payload)
				.then(response => {
					commit("UPDATE_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addReportFormField({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.addDynamicFormField(payload)
				.then(response => {
					commit("ADD_REPORT_FORM_FIELD", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateReportFormField({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.updateDynamicFormField(payload)
				.then(response => {
					commit("UPDATE_REPORT_FORM_FIELD", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteReportFormField({ commit }, id) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.deleteDynamicFormField(id)
				.then(response => {
					commit("DELETE_REPORT_FORM_FIELD", id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	sortReportFormField({ commit }, payload) {
		return new Promise((resolve, reject) => {
			// commit change first to optimize ux
			commit("SORT_REPORT_FORM_FIELD", payload);
			requestGQL.request
				.sortDynamicFormField(payload.map(field => field.id))
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchGeneralData({ commit }) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getGeneral()
				.then(response => {
					commit("SET_GENERAL_DATA", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};
